module.exports = __webpack_public_path__ + "media/images/news/news-96cc3afaa2aebc6c0147c5579c9acad9.png";